import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Dialog } from "@mui/material";
import { useState } from "react";
import { AppColors } from "../../../../util/AppColors";
import { extensionToMime } from "../../../../util/function";

const FilesWithCloseButton = ({
  files,
  onClickFile,
  center,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleFileClick = (fle, index) => {
    const mimeType = fle?.file?.type
      ? fle?.file?.type?.split("/")?.[0]
      : extensionToMime[
          fle?.previewUrl?.split(".").pop().split("?")[0].toLowerCase()
        ]?.split("/")?.[0];

    if (mimeType === "application") {
      // ✅ open pdf in new tab
      window.open(fle?.previewUrl, "_blank");
    } else if (mimeType === "image" || !mimeType) {
      // ✅ open popup for images
      setActiveIndex(index);
      setOpen(true);
    }
  };

  const imageFiles = files?.filter((fle) => {
    const mimeType = fle?.file?.type
      ? fle?.file?.type?.split("/")?.[0]
      : extensionToMime[
          fle?.previewUrl?.split(".").pop().split("?")[0].toLowerCase()
        ]?.split("/")?.[0];

    return mimeType === "image" || !mimeType;
  });

  return (
    <>
      <div
        className={`flex-row ${center ? "flex-center" : ""}`}
        // style={{
        //   pointerEvents: disabled ? "none" : "auto",
        //   opacity: disabled ? 0.5 : 1,
        // }}
      >
        {files?.length > 0 &&
          files?.map((fle, i) => {
            const mimeType = fle?.file?.type
              ? fle?.file?.type?.split("/")?.[0]
              : extensionToMime[
                  fle?.previewUrl?.split(".").pop().split("?")[0].toLowerCase()
                ]?.split("/")?.[0];

            return (
              <div
                style={{
                  display: "inline-block",
                  position: "relative",
                  marginLeft: i !== 0 ? 15 : 0,
                }}
                key={i + mimeType}
              >
                {mimeType === "application" ? (
                  <PictureAsPdfIcon
                    className="upload-pdf"
                    sx={{ color: AppColors.redBtn }}
                    onClick={() => handleFileClick(fle, i)}
                  />
                ) : mimeType === "image" || !mimeType ? (
                  <img
                    className="upload-img"
                    alt=""
                    src={fle?.previewUrl}
                    onClick={() => handleFileClick(fle, i)}
                  />
                ) : mimeType === "video" ? (
                  <video
                    className="upload-img"
                    alt=""
                    src={fle?.previewUrl}
                    onClick={() => handleFileClick(fle, i)}
                  />
                ) : null}
                {!disabled ? (
                  <CloseIcon
                    sx={{ width: 20, height: 20, color: AppColors.red2 }}
                    className="img-close cursor"
                    onClick={() => onClickFile(i, fle)}
                  />
                ) : null}
              </div>
            );
          })}
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <div className="flex-center relative pv20">
          {imageFiles?.length > 0 && (
            <img
              src={imageFiles[activeIndex]?.previewUrl}
              alt=""
              style={{ maxHeight: "70vh", maxWidth: "100%" }}
              className="br10"
            />
          )}

          {/* Close button */}
          <CloseIcon
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              color: AppColors.red2,
            }}
            onClick={() => setOpen(false)}
          />

          {/* Left arrow */}
          {imageFiles?.length > 1 && activeIndex > 0 && (
            <div
              onClick={() => setActiveIndex((prev) => prev - 1)}
              style={{
                position: "absolute",
                left: 10,
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                background: "rgba(0,0,0,0.3)",
                borderRadius: "50%",
                width: 30,
                height: 30,
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <ChevronLeftIcon sx={{ color: "white", fontSize: 20 }} />
            </div>
          )}

          {/* Right arrow */}
          {imageFiles?.length > 1 && activeIndex < imageFiles.length - 1 && (
            <div
              onClick={() => setActiveIndex((prev) => prev + 1)}
              style={{
                position: "absolute",
                right: 10,
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                background: "rgba(0,0,0,0.3)",
                borderRadius: "50%",
                width: 30,
                height: 30,
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <ChevronRightIcon sx={{ color: "white", fontSize: 20 }} />
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default FilesWithCloseButton;
